import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { LogService } from 'src/app/shared/services/log.service';
import { Note } from '../models/note.model';
import { MembersFollowup } from '../models/members-followup.model';
import { GetFollowupActivity } from '../models/getFollowupActivity.model';
import { GetPlannedFollowup } from '../models/getPlannedFollowup.model';
import { UpdatePlannedFollowup } from '../models/updateFollowup.model';
import { FollowupNotification } from '../models/followupNotification.model';

@Injectable({ providedIn: 'root' })
export class FollowupService {
  apiHost: string = environment.apiHost;
  constructor(private http: HttpClient, private logService: LogService) {}

  addFollowup(membersFollowup: MembersFollowup): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Followup/AddFollowup', membersFollowup)
        .toPromise()
        .then(
          (data) => {
            resolve(null);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Add Followup Tasks', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  updateFollowup(updateFollowup: UpdatePlannedFollowup): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Followup/UpdateFollowup', updateFollowup)
        .toPromise()
        .then(
          (data) => {
            resolve(null);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: update Followup Tasks', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  limitedUpdateFollowup(
    id: number,
    status: number,
    activity: number,
    date: Date
  ): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost +
            '/Followup/limitedUpdateFollowup?id=' +
            id.toString() +
            '&status=' +
            status.toString() +
            '&activity=' +
            activity +
            '&date=' +
            date.toLocaleString(),
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(null);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: limited update Followup Tasks',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  deleteFollowupByAssigner(
    assigner: number,
    memberIds: number[]
  ): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost +
            '/Followup/DeleteFollowupByAssigner?Assigner=' +
            assigner,
          memberIds
        )
        .toPromise()
        .then(
          (data) => {
            resolve(null);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: delete Followup by assigner',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  deleteFollowupByMember(memberId: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost +
            '/Followup/DeleteFollowupByMember?MemberId=' +
            memberId,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(null);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: delete Followup by member', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  deleteFollowup(followupId: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost + '/Followup/DeleteFollowup?followupId=' + followupId,
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(null);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: delete Followup by id', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  GetFollowupsCount(assignee: number): Promise<number> {
    let promise = new Promise<number>((resolve, reject) => {
      return this.http
        .get<number>(
          this.apiHost + '/Followup/GetFollowupsCount?Assignee=' + assignee
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Task Count ', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  GetFollowupByAssignee(assignee: number): Promise<GetPlannedFollowup[]> {
    let promise = new Promise<GetPlannedFollowup[]>((resolve, reject) => {
      return this.http
        .get<GetPlannedFollowup[]>(
          this.apiHost + '/Followup/GetFollowupByAssignee?Assignee=' + assignee
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Get Followups By Assignee ',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  GetFollowupActivity(MemberId: number): Promise<GetFollowupActivity[]> {
    let promise = new Promise<GetFollowupActivity[]>((resolve, reject) => {
      return this.http
        .get<GetFollowupActivity[]>(
          this.apiHost + '/Followup/GetFollowupActivity?MemberId=' + MemberId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Followup Activity ', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  GetNotificationsByAssigner(AssignerId: number): Promise<FollowupNotification[]> {
    let promise = new Promise<FollowupNotification[]>((resolve, reject) => {
      return this.http
        .get<FollowupNotification[]>(
          this.apiHost + '/Followup/GetNotificationsByAssigner?AssignerId=' + AssignerId
        )
        .toPromise()
        .then(
          (data) => {  
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Notifications by Assignee ', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  ClearNotification(NotificationId: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost + '/Followup/ClearNotification?NotificationId=' + NotificationId, null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Clear Notification ', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  GetNotificationsCount(AssignerId: number): Promise<number> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .get<any>(
          this.apiHost + '/Followup/GetNotificationsCount?AssignerId=' + AssignerId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data.count);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Notifications Count ', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }
}
